import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';
import { toast } from 'react-toastify';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import bindModel from '../../../common/bindModel.js';

export default class ModalUpdateBeat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            song: {
                title: '',
                youtubeId: '',
                coverUrl: '',
                videoUrl: '',
                artistIds: [],
                genreIds: [],
                genreNames: [],
                keyTone: '',
                tempo: '',
                timeSignature: '4/4',
                typeOfBeat: 1,
                status: 1, // ACTIVE/PUBLISHED (mặc định khi tạo mới)
                intro: '',
                lyrics: '',
                chords: '',
                instruction: '',
                // Bài học hát
                lessonYoutubeId: '',
                lessonTitle: '',
                lessonCoverUrl: '',
                lessonVideoUrl: '',
                lessonTeacherId: ''
            },
            loading: false,
            fetchingVideo: false,
            fetchingLessonVideo: false,
            availableArtists: [],
            previousYoutubeId: '', // Track previous youtubeId để so sánh khi blur
            previousLessonYoutubeId: '' // Track previous lessonYoutubeId để so sánh khi blur
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleYoutubeIdChange = this.handleYoutubeIdChange.bind(this);
        this.handleYoutubeIdBlur = this.handleYoutubeIdBlur.bind(this);
        this.fetchVideoUrl = this.fetchVideoUrl.bind(this);
        this.handleCoverUrlChange = this.handleCoverUrlChange.bind(this);
        this.handleArtistChange = this.handleArtistChange.bind(this);
        this.handleGenreChange = this.handleGenreChange.bind(this);
        this.handleLessonYoutubeIdChange = this.handleLessonYoutubeIdChange.bind(this);
        this.handleLessonYoutubeIdBlur = this.handleLessonYoutubeIdBlur.bind(this);
        this.fetchLessonVideoUrl = this.fetchLessonVideoUrl.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { song } = nextProps;
        
        if (song) {
            // Extract youtubeId from videoUrl if exists (only if it's a YouTube URL)
            // Otherwise, try to extract from coverUrl if it's YouTube thumbnail
            let youtubeId = '';
            if (song.videoUrl) {
                const match = song.videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
                if (match) {
                    youtubeId = match[1];
                }
            }
            // If not found in videoUrl, try to extract from coverUrl (YouTube thumbnail)
            if (!youtubeId && song.coverUrl) {
                const coverMatch = song.coverUrl.match(/youtube\.com\/vi\/([^\/]+)/);
                if (coverMatch) {
                    youtubeId = coverMatch[1];
                }
            }
            
            this.setState({
                song: {
                    id: song.id,
                    title: song.title || '',
                    youtubeId: youtubeId,
                    coverUrl: song.coverUrl || (youtubeId ? `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg` : ''),
                    videoUrl: song.videoUrl || '',
                    artistIds: song.artistIds || [],
                    genreIds: song.genreIds || [],
                    genreNames: song.genreNames || [],
                    keyTone: song.keyTone || '',
                    tempo: song.tempo || '',
                    timeSignature: song.timeSignature || '4/4',
                    typeOfBeat: song.typeOfBeat || 1,
                    status: song.status !== undefined ? song.status : 1,
                    intro: song.intro || '',
                    lyrics: song.lyrics || '',
                    chords: song.chords || '',
                    instruction: song.instruction || '',
                    // Bài học hát
                    lessonYoutubeId: song.lessonYoutubeId || '',
                    lessonTitle: song.lessonTitle || '',
                    lessonCoverUrl: song.lessonCoverUrl || '',
                    lessonVideoUrl: song.lessonVideoUrl || '',
                    lessonTeacherId: song.lessonTeacherId || ''
                },
                previousYoutubeId: youtubeId, // Set previousYoutubeId khi load song
                previousLessonYoutubeId: song.lessonYoutubeId || '' // Set previousLessonYoutubeId khi load song
            });
        } else {
            this.setState({
                song: {
                    title: '',
                    youtubeId: '',
                    coverUrl: '',
                    videoUrl: '',
                    artistIds: [],
                    genreIds: [],
                    genreNames: [],
                    keyTone: '',
                    tempo: '',
                    timeSignature: '4/4',
                    typeOfBeat: 1,
                    status: 1, // ACTIVE/PUBLISHED (mặc định khi tạo mới)
                    intro: '',
                    lyrics: '',
                    chords: '',
                    instruction: '',
                    // Bài học hát
                    lessonYoutubeId: '',
                    lessonTitle: '',
                    lessonCoverUrl: '',
                    lessonVideoUrl: '',
                    lessonTeacherId: ''
                },
                previousYoutubeId: '', // Reset previousYoutubeId khi tạo mới
                previousLessonYoutubeId: '' // Reset previousLessonYoutubeId khi tạo mới
            });
        }
    }

    componentDidMount() {
        this.loadArtists();
    }

    loadArtists() {
        const url = `${global.config.apiDomain}/yt-song/web/artist`;
        
        axios.get(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                let artistsData = [];
                
                if (res.data && res.data.data && Array.isArray(res.data.data.artists)) {
                    artistsData = res.data.data.artists;
                } else if (Array.isArray(res.data)) {
                    artistsData = res.data;
                } else if (res.data && Array.isArray(res.data.data)) {
                    artistsData = res.data.data;
                } else if (res.data && res.data.status === 'OK' && res.data.data && Array.isArray(res.data.data.artists)) {
                    artistsData = res.data.data.artists;
                } else if (res.data && res.data.status === 'OK' && Array.isArray(res.data.data)) {
                    artistsData = res.data.data;
                }
                
                // Chỉ lấy những ca sĩ có status là ACTIVE
                const activeArtists = artistsData.filter(artist => artist.status === 'ACTIVE');
                
                this.setState({ availableArtists: activeArtists });
            })
            .catch(error => {
                console.error('Không thể tải danh sách ca sĩ:', error);
            });
    }

    handleYoutubeIdChange(e) {
        const youtubeId = e.target.value.trim();
        
        // Chỉ cập nhật youtubeId trong state, không tự động fetch hay cập nhật title/coverUrl
        this.setState({
            song: {
                ...this.state.song,
                youtubeId: youtubeId
            }
        });
    }

    handleYoutubeIdBlur(e) {
        const youtubeId = e.target.value.trim();
        const { previousYoutubeId } = this.state;
        
        // Chỉ fetch và cập nhật nếu youtubeId thay đổi và hợp lệ
        if (youtubeId && youtubeId.length >= 11 && youtubeId !== previousYoutubeId) {
            // Cập nhật coverUrl từ YouTube thumbnail
            const newCoverUrl = `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`;
            
            this.setState({
                song: {
                    ...this.state.song,
                    coverUrl: newCoverUrl
                },
                previousYoutubeId: youtubeId
            });
            
            // Fetch videoUrl và title từ API
            this.fetchVideoUrl(youtubeId);
        } else if (!youtubeId && previousYoutubeId) {
            // Nếu xóa youtubeId, reset title và coverUrl về rỗng
            this.setState({
                song: {
                    ...this.state.song,
                    title: '',
                    coverUrl: '',
                    videoUrl: ''
                },
                previousYoutubeId: ''
            });
        }
    }

    fetchVideoUrl(youtubeId) {
        if (!youtubeId || youtubeId.length < 11) {
            toast.warning('Youtube ID không hợp lệ');
            return;
        }

        this.setState({ fetchingVideo: true });
        
        // Sử dụng endpoint proxy từ backend để tránh lỗi CORS
        const proxyUrl = `${global.config.apiDomain}/yt-song/web/karaoke-song/youtube-info/${youtubeId}`;
        
        axios.get(proxyUrl, {
            timeout: 30000, // 30 seconds timeout
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                // API trả về: {"cached":true,"filename":"CP1izMfLOVU.mp4","ok":true,"url":"...","title":"Tên bài hát"}
                const videoUrl = res.data?.url;
                const title = res.data?.title || '';
                
                if (videoUrl && res.data?.ok) {
                    // Cập nhật videoUrl, title và coverUrl từ YouTube
                    const coverUrl = `https://img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`;
                    
                    this.setState({
                        song: {
                            ...this.state.song,
                            videoUrl: videoUrl,
                            title: title || this.state.song.title, // Giữ title cũ nếu API không trả về
                            coverUrl: coverUrl
                        },
                        fetchingVideo: false
                    });
                    toast.success(title ? `Lấy video URL và title thành công: ${title}` : 'Lấy video URL thành công');
                } else {
                    this.setState({ fetchingVideo: false });
                    toast.warning('Không thể lấy video URL từ API. Vui lòng kiểm tra lại YouTube ID.');
                }
            })
            .catch(error => {
                this.setState({ fetchingVideo: false });
                
                let errorMessage = 'Không thể lấy video URL';
                
                // Xử lý các loại lỗi khác nhau
                if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
                    errorMessage = 'Request timeout. Vui lòng thử lại sau.';
                } else if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
                    errorMessage = 'Lỗi kết nối mạng. Vui lòng kiểm tra kết nối internet và thử lại.';
                } else if (error.response) {
                    // Server trả về response nhưng có lỗi
                    errorMessage = error.response.data?.message || `Lỗi ${error.response.status}: ${error.response.statusText}`;
                } else if (error.request) {
                    // Request được gửi nhưng không nhận được response
                    errorMessage = 'Không nhận được phản hồi từ server. Vui lòng thử lại sau.';
                } else {
                    errorMessage = error.message || 'Đã xảy ra lỗi không xác định';
                }
                
                console.error('Error fetching video URL:', error);
                toast.error(errorMessage);
            });
    }

    handleLessonYoutubeIdChange(e) {
        const lessonYoutubeId = e.target.value.trim();
        
        // Chỉ cập nhật lessonYoutubeId trong state, không tự động fetch hay cập nhật title/coverUrl
        this.setState({
            song: {
                ...this.state.song,
                lessonYoutubeId: lessonYoutubeId
            }
        });
    }

    handleLessonYoutubeIdBlur(e) {
        const lessonYoutubeId = e.target.value.trim();
        const { previousLessonYoutubeId } = this.state;
        
        // Chỉ fetch và cập nhật nếu lessonYoutubeId thay đổi và hợp lệ
        if (lessonYoutubeId && lessonYoutubeId.length >= 11 && lessonYoutubeId !== previousLessonYoutubeId) {
            // Cập nhật lessonCoverUrl từ YouTube thumbnail
            const newLessonCoverUrl = `https://img.youtube.com/vi/${lessonYoutubeId}/maxresdefault.jpg`;
            
            this.setState({
                song: {
                    ...this.state.song,
                    lessonCoverUrl: newLessonCoverUrl
                },
                previousLessonYoutubeId: lessonYoutubeId
            });
            
            // Fetch lessonVideoUrl và lessonTitle từ API
            this.fetchLessonVideoUrl(lessonYoutubeId);
        } else if (!lessonYoutubeId && previousLessonYoutubeId) {
            // Nếu xóa lessonYoutubeId, reset lesson fields về rỗng
            this.setState({
                song: {
                    ...this.state.song,
                    lessonTitle: '',
                    lessonCoverUrl: '',
                    lessonVideoUrl: ''
                },
                previousLessonYoutubeId: ''
            });
        }
    }

    fetchLessonVideoUrl(lessonYoutubeId) {
        if (!lessonYoutubeId || lessonYoutubeId.length < 11) {
            toast.warning('Youtube ID bài học không hợp lệ');
            return;
        }

        this.setState({ fetchingLessonVideo: true });
        
        // Sử dụng endpoint proxy từ backend để tránh lỗi CORS
        const proxyUrl = `${global.config.apiDomain}/yt-song/web/karaoke-song/youtube-info/${lessonYoutubeId}`;
        
        axios.get(proxyUrl, {
            timeout: 30000, // 30 seconds timeout
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                // API trả về: {"cached":true,"filename":"CP1izMfLOVU.mp4","ok":true,"url":"...","title":"Tên bài học"}
                const lessonVideoUrl = res.data?.url;
                const lessonTitle = res.data?.title || '';
                
                if (lessonVideoUrl && res.data?.ok) {
                    // Cập nhật lessonVideoUrl, lessonTitle và lessonCoverUrl từ YouTube
                    const lessonCoverUrl = `https://img.youtube.com/vi/${lessonYoutubeId}/maxresdefault.jpg`;
                    
                    this.setState({
                        song: {
                            ...this.state.song,
                            lessonVideoUrl: lessonVideoUrl,
                            lessonTitle: lessonTitle || this.state.song.lessonTitle, // Giữ title cũ nếu API không trả về
                            lessonCoverUrl: lessonCoverUrl
                        },
                        fetchingLessonVideo: false
                    });
                    toast.success(lessonTitle ? `Lấy video URL và title bài học thành công: ${lessonTitle}` : 'Lấy video URL bài học thành công');
                } else {
                    this.setState({ fetchingLessonVideo: false });
                    toast.warning('Không thể lấy video URL bài học từ API. Vui lòng kiểm tra lại YouTube ID.');
                }
            })
            .catch(error => {
                this.setState({ fetchingLessonVideo: false });
                
                let errorMessage = 'Không thể lấy video URL bài học';
                
                // Xử lý các loại lỗi khác nhau
                if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
                    errorMessage = 'Request timeout. Vui lòng thử lại sau.';
                } else if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
                    errorMessage = 'Lỗi kết nối mạng. Vui lòng kiểm tra kết nối internet và thử lại.';
                } else if (error.response) {
                    // Server trả về response nhưng có lỗi
                    errorMessage = error.response.data?.message || `Lỗi ${error.response.status}: ${error.response.statusText}`;
                } else if (error.request) {
                    // Request được gửi nhưng không nhận được response
                    errorMessage = 'Không nhận được phản hồi từ server. Vui lòng thử lại sau.';
                } else {
                    errorMessage = error.message || 'Đã xảy ra lỗi không xác định';
                }
                
                console.error('Error fetching lesson video URL:', error);
                toast.error(errorMessage);
            });
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    handleArtistChange(selectedOptions) {
        const artistIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
        this.setState({
            song: {
                ...this.state.song,
                artistIds: artistIds
            }
        });
    }

    handleGenreChange(selectedOptions) {
        // Khi chọn thể loại, cả genreIds và genreNames đều là danh sách tên thể loại
        const genres = selectedOptions ? selectedOptions.map(option => option.value) : [];
        this.setState({
            song: {
                ...this.state.song,
                genreIds: genres,
                genreNames: genres // genreNames giống genreIds (tên thể loại)
            }
        });
    }

    handleCoverUrlChange(e) {
        const target = e.target;
        const file = target.files[0];
        
        if (!file) return;

        // Validate file type
        if (!file.type.startsWith('image/')) {
            toast.warning('Vui lòng chọn file ảnh');
            return;
        }

        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
            toast.warning('Kích thước file không được vượt quá 5MB');
            return;
        }

        this.setState({ loading: true });

        const bucketName = "ikara-data/images/karaoke-beats";
        const extension = file.name.split('.').pop().toLowerCase();
        const keyName = this.guid() + "." + extension;
        let contentType = "image/jpeg";
        if (extension === "png") contentType = "image/png";
        if (extension === "gif") contentType = "image/gif";
        if (extension === "webp") contentType = "image/webp";

        const fileReader = new FileReader();

        fileReader.onload = function () {
            const fd = new FormData();
            fd.append('file', file);
            fd.append('bucketName', bucketName);
            fd.append('objectKey', keyName);
            fd.append('contentType', contentType);
            
            $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (data) {
                    this.setState({
                        loading: false
                    });

                    const imageUrl = 'https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName;
                    this.setState({
                        song: {
                            ...this.state.song,
                            coverUrl: imageUrl
                        }
                    });
                    toast.success('Upload ảnh thành công');
                }.bind(this),
                error: function (xhr, status, error) {
                    console.error('Error:', error);
                    this.setState({
                        loading: false
                    });
                    toast.error('Lỗi khi upload ảnh. Vui lòng thử lại.');
                }.bind(this)
            });
        }.bind(this);

        fileReader.readAsArrayBuffer(file);
    }

    handleSubmit() {
        const { song } = this.state;
        const { onSuccess } = this.props;

        // Validation
        if (!song.title || song.title.trim() === '') {
            toast.warning('Vui lòng nhập tên bài hát');
            return;
        }

        if (!song.videoUrl || song.videoUrl.trim() === '') {
            toast.warning('Vui lòng nhập Youtube ID và lấy video URL');
            return;
        }

        this.setState({ loading: true });

        const isUpdate = song.id;
        const url = isUpdate 
            ? `${global.config.apiDomain}/yt-song/web/karaoke-song/${song.id}`
            : `${global.config.apiDomain}/yt-song/web/karaoke-song`;

        const method = isUpdate ? 'put' : 'post';
        
        // Prepare data
        // Set coverUrl: use existing, or YouTube thumbnail if youtubeId exists, or empty
        let coverUrl = song.coverUrl;
        if (!coverUrl && song.youtubeId) {
            coverUrl = `https://img.youtube.com/vi/${song.youtubeId}/maxresdefault.jpg`;
        }
        
        // Prepare lesson data - chỉ thêm nếu có giá trị
        const lessonData = {};
        if (song.lessonYoutubeId && typeof song.lessonYoutubeId === 'string' && song.lessonYoutubeId.trim()) {
            lessonData.lessonYoutubeId = song.lessonYoutubeId.trim();
        }
        if (song.lessonTitle && typeof song.lessonTitle === 'string' && song.lessonTitle.trim()) {
            lessonData.lessonTitle = song.lessonTitle.trim();
        }
        if (song.lessonCoverUrl && typeof song.lessonCoverUrl === 'string' && song.lessonCoverUrl.trim()) {
            lessonData.lessonCoverUrl = song.lessonCoverUrl.trim();
        }
        if (song.lessonVideoUrl && typeof song.lessonVideoUrl === 'string' && song.lessonVideoUrl.trim()) {
            lessonData.lessonVideoUrl = song.lessonVideoUrl.trim();
        }
        if (song.lessonTeacherId) {
            // lessonTeacherId có thể là string hoặc number
            const teacherId = typeof song.lessonTeacherId === 'string' 
                ? song.lessonTeacherId.trim() 
                : String(song.lessonTeacherId);
            if (teacherId) {
                lessonData.lessonTeacherId = teacherId;
            }
        }
        
        // Prepare genre data - chỉ thêm nếu có giá trị
        const genreData = {};
        if (song.genreIds && song.genreIds.length > 0) {
            genreData.genreIds = song.genreIds;
        }
        if (song.genreNames && song.genreNames.length > 0) {
            genreData.genreNames = song.genreNames;
        }

        const data = {
            title: song.title.trim(),
            videoUrl: song.videoUrl.trim(),
            coverUrl: coverUrl || '',
            artistIds: song.artistIds || [],
            keyTone: song.keyTone || '',
            tempo: song.tempo ? parseInt(song.tempo, 10) : undefined,
            timeSignature: song.timeSignature || '4/4',
            typeOfBeat: song.typeOfBeat || 1,
            status: isUpdate ? (song.status !== undefined ? song.status : 1) : 1, // Mặc định 1 (ACTIVE/PUBLISHED) khi tạo mới
            intro: song.intro || '',
            lyrics: song.lyrics || '',
            chords: song.chords || '',
            instruction: song.instruction || '',
            // Thể loại nhạc - chỉ thêm nếu có giá trị
            ...genreData,
            // Bài học hát - chỉ thêm nếu có giá trị
            ...lessonData
        };

        axios[method](url, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                this.setState({ loading: false });
                toast.success(isUpdate ? 'Cập nhật beat thành công' : 'Tạo beat thành công');
                window.$('#ModalUpdateBeat').modal('hide');
                if (onSuccess) {
                    onSuccess();
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                const errorMessage = error.response?.data?.message || error.message || 'Đã xảy ra lỗi';
                toast.error(errorMessage);
            });
    }

    render() {
        const model = bindModel(this);
        const { song, loading, fetchingVideo, fetchingLessonVideo, availableArtists } = this.state;
        const isUpdate = !!song.id;

        return (
            <div className="modal fade" id="ModalUpdateBeat" tabIndex={-1} role="dialog" aria-labelledby="ModalUpdateBeatTitle" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document" style={{ maxWidth: '900px' }}>
                    <div className="modal-content">
                        <div className="modal-header bg-success text-white">
                            <h5 className="modal-title" id="ModalUpdateBeatTitle">
                                {isUpdate ? 'Cập nhật beat' : 'Thêm beat mới'}
                            </h5>
                            <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            <div className="form-group">
                                <label htmlFor="songTitle">
                                    <strong>Tên bài hát <span className="text-danger">*</span></strong>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="songTitle"
                                    placeholder="Nhập tên bài hát"
                                    {...model('song.title')}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="youtubeId">
                                    <strong>Youtube ID <span className="text-danger">*</span></strong>
                                </label>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="youtubeId"
                                        placeholder="Nhập Youtube ID (ví dụ: CP1izMfLOVU)"
                                        value={song.youtubeId || ''}
                                        onChange={this.handleYoutubeIdChange}
                                        onBlur={this.handleYoutubeIdBlur}
                                    />
                                    <div className="input-group-append">
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={() => this.fetchVideoUrl(song.youtubeId)}
                                            disabled={!song.youtubeId || fetchingVideo}
                                        >
                                            {fetchingVideo ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm mr-1" role="status"></span>
                                                    Đang lấy...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa-solid fa-download mr-1"></i>
                                                    Lấy Video URL
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                                <small className="form-text text-muted">
                                    Nhập Youtube ID (ví dụ: từ URL https://www.youtube.com/watch?v=CP1izMfLOVU thì ID là CP1izMfLOVU)
                                </small>
                                {song.videoUrl && (
                                    <div className="mt-2">
                                        <small className="text-success">
                                            <i className="fa-solid fa-check mr-1"></i>
                                            Video URL: {song.videoUrl.substring(0, 80)}...
                                        </small>
                                    </div>
                                )}
                            </div>

                            <div className="form-group">
                                <label htmlFor="coverUrl">
                                    <strong>Ảnh bìa</strong>
                                </label>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="coverUrl"
                                        placeholder="URL ảnh bìa"
                                        value={song.coverUrl || ''}
                                        onChange={(e) => {
                                            this.setState({
                                                song: {
                                                    ...song,
                                                    coverUrl: e.target.value
                                                }
                                            });
                                        }}
                                    />
                                    <div className="input-group-append">
                                        <label className="btn btn-outline-secondary mb-0" style={{ cursor: 'pointer' }}>
                                            <i className="fa-solid fa-upload mr-1"></i>
                                            Upload
                                            <input
                                                type="file"
                                                accept="image/*"
                                                style={{ display: 'none' }}
                                                onChange={this.handleCoverUrlChange}
                                            />
                                        </label>
                                    </div>
                                </div>
                                {song.coverUrl && (
                                    <div className="mt-2">
                                        <img 
                                            src={song.coverUrl} 
                                            alt="Preview"
                                            style={{ 
                                                maxWidth: '200px', 
                                                maxHeight: '200px',
                                                borderRadius: '8px',
                                                border: '1px solid #ddd'
                                            }}
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    </div>
                                )}
                                <small className="form-text text-muted">
                                    Ảnh bìa mặc định sẽ được lấy từ YouTube thumbnail. Bạn có thể upload ảnh khác.
                                </small>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="keyTone">
                                            <strong>Giọng (Key Tone)</strong>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="keyTone"
                                            placeholder="C#, Dm, etc."
                                            {...model('song.keyTone')}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="tempo">
                                            <strong>Tempo (BPM)</strong>
                                        </label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="tempo"
                                            placeholder="120"
                                            min="60"
                                            max="200"
                                            {...model('song.tempo')}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="timeSignature">
                                            <strong>Nhịp</strong>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="timeSignature"
                                            placeholder="4/4, 3/4, 2/4, 6/8, etc."
                                            {...model('song.timeSignature')}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="typeOfBeat">
                                            <strong>Loại beat</strong>
                                        </label>
                                        <select
                                            className="form-control"
                                            id="typeOfBeat"
                                            value={song.typeOfBeat || 1}
                                            onChange={(e) => {
                                                this.setState({
                                                    song: {
                                                        ...song,
                                                        typeOfBeat: parseInt(e.target.value, 10)
                                                    }
                                                });
                                            }}
                                        >
                                            <option value={1}>Beat Ca sĩ</option>
                                            <option value={2}>Beat Học hát</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="artistIds">
                                    <strong>Ca sĩ</strong>
                                </label>
                                <Select
                                    isMulti
                                    name="artists"
                                    options={availableArtists.map(artist => ({
                                        value: artist.id,
                                        label: artist.name
                                    }))}
                                    value={availableArtists
                                        .filter(artist => song.artistIds && song.artistIds.includes(artist.id))
                                        .map(artist => ({
                                            value: artist.id,
                                            label: artist.name
                                        }))}
                                    onChange={this.handleArtistChange}
                                    placeholder="Tìm kiếm và chọn ca sĩ..."
                                    noOptionsMessage={() => "Không tìm thấy ca sĩ"}
                                    isSearchable={true}
                                    isClearable={true}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '38px',
                                            borderColor: '#ced4da'
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999
                                        })
                                    }}
                                />
                                <small className="form-text text-muted">
                                    Gõ để tìm kiếm và chọn nhiều ca sĩ
                                </small>
                            </div>

                            <div className="form-group">
                                <label htmlFor="genreIds">
                                    <strong>Thể loại nhạc</strong>
                                </label>
                                <CreatableSelect
                                    isMulti
                                    name="genres"
                                    options={[]} // Không có danh sách sẵn, cho phép tạo mới
                                    value={song.genreNames && song.genreNames.length > 0
                                        ? song.genreNames.map(genre => ({
                                            value: genre,
                                            label: genre
                                        }))
                                        : []}
                                    onChange={this.handleGenreChange}
                                    placeholder="Nhập và chọn thể loại nhạc..."
                                    noOptionsMessage={() => "Gõ để tạo thể loại mới"}
                                    isSearchable={true}
                                    isClearable={true}
                                    formatCreateLabel={(inputValue) => `Tạo "${inputValue}"`}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '38px',
                                            borderColor: '#ced4da'
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999
                                        })
                                    }}
                                />
                                <small className="form-text text-muted">
                                    Gõ để tạo thể loại mới hoặc chọn từ danh sách (ví dụ: Pop, Ballad, Rock, EDM...)
                                </small>
                            </div>

                            <div className="form-group">
                                <label htmlFor="intro">
                                    <strong>Giới thiệu</strong>
                                </label>
                                <textarea
                                    className="form-control"
                                    id="intro"
                                    rows="3"
                                    placeholder="Nhập giới thiệu bài hát"
                                    {...model('song.intro')}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="lyrics">
                                    <strong>Lời bài hát</strong>
                                </label>
                                <textarea
                                    className="form-control"
                                    id="lyrics"
                                    rows="5"
                                    placeholder="Nhập lời bài hát"
                                    {...model('song.lyrics')}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="chords">
                                    <strong>Lời + hợp âm</strong>
                                </label>
                                <textarea
                                    className="form-control"
                                    id="chords"
                                    rows="5"
                                    placeholder="Nhập lời bài hát kèm hợp âm"
                                    {...model('song.chords')}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="instruction">
                                    <strong>Hướng dẫn hát</strong>
                                </label>
                                <textarea
                                    className="form-control"
                                    id="instruction"
                                    rows="3"
                                    placeholder="Nhập hướng dẫn hát"
                                    {...model('song.instruction')}
                                />
                            </div>

                            <hr className="my-4" />
                            <h5 className="mb-3">
                                <i className="fa-solid fa-graduation-cap mr-2"></i>
                                Bài học hát (Tùy chọn)
                            </h5>

                            <div className="form-group">
                                <label htmlFor="lessonYoutubeId">
                                    <strong>Youtube ID bài học</strong>
                                </label>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="lessonYoutubeId"
                                        placeholder="Nhập Youtube ID bài học (ví dụ: abc123xyz)"
                                        value={song.lessonYoutubeId || ''}
                                        onChange={this.handleLessonYoutubeIdChange}
                                        onBlur={this.handleLessonYoutubeIdBlur}
                                    />
                                    <div className="input-group-append">
                                        <button
                                            className="btn btn-outline-secondary"
                                            type="button"
                                            onClick={() => this.fetchLessonVideoUrl(song.lessonYoutubeId)}
                                            disabled={!song.lessonYoutubeId || fetchingLessonVideo}
                                        >
                                            {fetchingLessonVideo ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm mr-1" role="status"></span>
                                                    Đang lấy...
                                                </>
                                            ) : (
                                                <>
                                                    <i className="fa-solid fa-download mr-1"></i>
                                                    Lấy Video URL
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                                <small className="form-text text-muted">
                                    Nhập Youtube ID của video bài học hát (nếu có)
                                </small>
                                {song.lessonVideoUrl && (
                                    <div className="mt-2">
                                        <small className="text-success">
                                            <i className="fa-solid fa-check mr-1"></i>
                                            Video URL: {song.lessonVideoUrl.substring(0, 80)}...
                                        </small>
                                    </div>
                                )}
                            </div>

                            <div className="form-group">
                                <label htmlFor="lessonTitle">
                                    <strong>Tên bài học</strong>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="lessonTitle"
                                    placeholder="Tên bài học hát"
                                    {...model('song.lessonTitle')}
                                />
                                <small className="form-text text-muted">
                                    Tên bài học sẽ được tự động lấy từ YouTube khi nhập Youtube ID
                                </small>
                            </div>

                            <div className="form-group">
                                <label htmlFor="lessonCoverUrl">
                                    <strong>Ảnh bìa bài học</strong>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="lessonCoverUrl"
                                    placeholder="URL ảnh bìa bài học"
                                    value={song.lessonCoverUrl || ''}
                                    onChange={(e) => {
                                        this.setState({
                                            song: {
                                                ...song,
                                                lessonCoverUrl: e.target.value
                                            }
                                        });
                                    }}
                                />
                                {song.lessonCoverUrl && (
                                    <div className="mt-2">
                                        <img 
                                            src={song.lessonCoverUrl} 
                                            alt="Lesson Preview"
                                            style={{ 
                                                maxWidth: '200px', 
                                                maxHeight: '200px',
                                                borderRadius: '8px',
                                                border: '1px solid #ddd'
                                            }}
                                            onError={(e) => {
                                                e.target.style.display = 'none';
                                            }}
                                        />
                                    </div>
                                )}
                                <small className="form-text text-muted">
                                    Ảnh bìa sẽ được tự động lấy từ YouTube thumbnail khi nhập Youtube ID
                                </small>
                            </div>

                            <div className="form-group">
                                <label htmlFor="lessonTeacherId">
                                    <strong>Giáo viên</strong>
                                </label>
                                <Select
                                    name="lessonTeacher"
                                    options={availableArtists
                                        .filter(artist => artist.type === 2) // Chỉ lấy giáo viên (type = 2)
                                        .map(artist => ({
                                            value: String(artist.id), // Đảm bảo value là string
                                            label: artist.name
                                        }))}
                                    value={(() => {
                                        if (!song.lessonTeacherId) return null;
                                        const teacherId = String(song.lessonTeacherId); // Convert sang string để so sánh
                                        const teacher = availableArtists.find(artist => 
                                            artist.type === 2 && String(artist.id) === teacherId
                                        );
                                        return teacher ? {
                                            value: String(teacher.id),
                                            label: teacher.name
                                        } : null;
                                    })()}
                                    onChange={(selectedOption) => {
                                        this.setState({
                                            song: {
                                                ...song,
                                                lessonTeacherId: selectedOption ? selectedOption.value : ''
                                            }
                                        });
                                    }}
                                    placeholder="Chọn giáo viên..."
                                    isClearable={true}
                                    isSearchable={true}
                                    noOptionsMessage={() => "Không tìm thấy giáo viên"}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            minHeight: '38px',
                                            borderColor: '#ced4da'
                                        }),
                                        menu: (base) => ({
                                            ...base,
                                            zIndex: 9999
                                        })
                                    }}
                                />
                                <small className="form-text text-muted">
                                    Chọn giáo viên dạy bài học này (chỉ hiển thị các artist có type = 2)
                                </small>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                data-dismiss="modal"
                                disabled={loading || fetchingVideo || fetchingLessonVideo}
                            >
                                Hủy
                            </button>
                            {loading || fetchingVideo || fetchingLessonVideo ? (
                                <button type="button" className="btn btn-success" disabled>
                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                    {fetchingVideo ? 'Đang lấy video URL...' : fetchingLessonVideo ? 'Đang lấy video URL bài học...' : 'Đang xử lý...'}
                                </button>
                            ) : (
                                <button 
                                    type="button" 
                                    className="btn btn-success" 
                                    onClick={this.handleSubmit}
                                >
                                    <i className="fa-solid fa-check mr-2"></i>
                                    {isUpdate ? 'Cập nhật' : 'Tạo mới'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

